import { render, staticRenderFns } from "./GiftBoxList.vue?vue&type=template&id=27ff3401&scoped=true"
import script from "./GiftBoxList.vue?vue&type=script&lang=js"
export * from "./GiftBoxList.vue?vue&type=script&lang=js"
import style0 from "./GiftBoxList.vue?vue&type=style&index=0&id=27ff3401&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ff3401",
  null
  
)

export default component.exports